export const POSTHOG_URL = 'https://eu.posthog.com';
